import { Route, RouteProps, Routes } from 'react-router-dom'
import { lazy } from 'react'
import LoaderPage from 'components/ui/feedback/LoaderPage'

const WriteOffsPage = lazy(() => import('pages/writeOffs/page'))

const WriteOffRoutes: React.FunctionComponent<RouteProps> = () => {
  return (
    <Routes>
      <Route path="/" element={<LoaderPage content={<WriteOffsPage />} />} />
    </Routes>
  )
}

export default WriteOffRoutes

